<template>
	<!-- 古代言情 -->
	<div class="yanqingBox" :style="{ height: categoryIdx != null ? 100 + 'vh' : ''}">
		<!-- 头部 -->
		<van-sticky v-if="categoryIdx !=null ? true:false">
			<div class="headerBox">
				<div class="headerQuery">
					<div class="arrImg" @click="$router.go(-1)">
						<img src="../../assets/img/leftarr_tit.png" alt="">
					</div>
					<p class="header_titile">百合</p>
				</div>
			</div>
		</van-sticky>
		<van-pull-refresh v-model="isLoading" @refresh="onRefresh" loosing-text="正在获取">
		<div>
			<!-- 古代金榜 -->
			<div class="yunjin_jbBox">
				<h4>百合金榜<img src="../../assets/img/icon8.png" alt=""></h4>
				<div class="yunjin_jb">
					<swiper class="swiper" :options="jb_swiperOption">
						<div v-if="gyjb.length==0">

						</div>
						<swiper-slide else v-for='(item,index) in gyjb' :key='index' v-if='item.cover_image !=null'>
							<div @click="jumpBookinfo(item.book_id)">
								<div>
									<img :src="$api.$BASE_URL_img + item.cover_image" alt="">
								</div>
								<!-- <p class="bookName">{{item.book_name}}</p> -->
								<!-- <p class="jianjie">{{item.introduce}}</p> -->
								<p class="jianjie">
									<span v-for="(jianjieTxt,jianjieIndex) in item.introduce" v-if="jianjieIndex > 7 ? false : true">{{jianjieTxt}}</span>
								</p>
							</div>
						</swiper-slide>
					</swiper>
				</div>
			</div>
			<!-- 佳作欣赏 -->
			<div class="shouyeQt">
				<h4>佳作欣赏</h4>
				<div class="qt_list">
					<p v-for="(item,index) in jzxs" :key='index' @click="jumpBookinfo(item.book_id)">{{item.book_name}}</p>
				</div>
			</div>
			<!-- 封面强推 -->
			<div class="yunjin_jbBox">
				<h4>封面强推</h4>
				<div class="yunjin_jb">
					<swiper class="swiper" :options="jb_swiperOption">
						<swiper-slide v-for="(item,index) in fmqt" v-if='item.cover_image !=null'>
							<div @click="jumpBookinfo(item.book_id)">
								<div>
									<img :src="$api.$BASE_URL_img + item.cover_image" alt="">
								</div>
								<!-- 	<p class="bookName">
									<span v-for="(bookName,nameIndex) in item.book_name" v-if="nameIndex > 4 ? false : true">{{bookName}}</span>
								</p> -->
								<p class="jianjie">
									<span v-for="(jianjieTxt,jianjieIndex) in item.introduce" v-if="jianjieIndex > 7 ? false : true">{{jianjieTxt}}</span>
								</p>
							</div>
						</swiper-slide>
					</swiper>
				</div>
			</div>
			<!-- 热点关注 -->
			<div class="hot_gz">
				<h4>热点关注</h4>
				<div class="hotLists">
					<p v-for="(item,index) in rdgz" v-if="item.book_name != null" @click="jumpBookinfo(item.book_id)">{{item.book_name}}</p>
				</div>
			</div>
			<!-- 小图推荐 -->
			<div class="yunjin_jbBox">
				<h4>小图推荐</h4>
				<div class="yunjin_jb">
					<swiper class="swiper" :options="jb_swiperOption">
						<swiper-slide v-for='(item,index) in xttj' :key='index' v-if='item.cover_image !=null'>
							<div @click="jumpBookinfo(item.book_id)">
								<div>
									<img :src="$api.$BASE_URL_img + item.cover_image" alt="">
								</div>
								<!-- <p class="bookName">
									<span v-for="(bookName,nameIndex) in item.book_name" v-if="nameIndex > 4 ? false : true">{{bookName}}</span>
								</p> -->
								<p class="jianjie">
									<span v-for="(jianjieTxt,jianjieIndex) in item.introduce" v-if="jianjieIndex > 7 ? false : true">{{jianjieTxt}}</span>
								</p>
							</div>
						</swiper-slide>
					</swiper>
				</div>
			</div>
			<!-- 精品 -->
			<div class="jinpinBox">
				<div class="jinpin_left">
					<div class="jp_title" @click="jumpXdyq(gdyq.plate_info_id)">
						<h4>古代百合</h4>
						<div>
							<img src="../../assets/img/rightarr_pink.png" alt="">
						</div>
					</div>
					<div class="jp_bookName" v-if="index==0" @click="jumpBookinfo(item.book_id)" v-for='(item,index) in gdyq.list'
					 :key='index'>
						<div class="jp_bookImg">
							<img v-if='item.cover_image !=null' :src="$api.$BASE_URL_img + item.cover_image" alt="">
						</div>
						<div>
							<p><span v-for="(bookNam,boIdx) in item.book_name" v-if="boIdx >4 ? false : true">{{bookNam}}</span></p>
							<p><span v-for="(authorTxt,boIdx) in item.author" v-if="boIdx >4 ? false : true">{{authorTxt}}</span></p>
							<p><span v-for="(introduceTxt,boIdx) in item.introduce" v-if="boIdx >10 ? false : true">{{introduceTxt}}</span></p>
						</div>
					</div>
					<div class="bookNameList">
						<p v-for="(item,index) in gdyq.list" v-if="index>0&&index<4" :key='index' @click="jumpBookinfo(item.book_id)">{{item.book_name}}</p>
					</div>
				</div>
				<div class="jinpin_left">
					<div class="jp_title" @click="jumpXdyq(gdcy.plate_info_id)">
						<h4>现代百合</h4>
						<div>
							<img src="../../assets/img/rightarr_pink.png" alt="">
						</div>
					</div>
					<div class="jp_bookName" v-if="index==0" @click="jumpBookinfo(item.book_id)" v-for='(item,index) in gdcy.list'
					 :key='index'>
						<div class="jp_bookImg">
							<img v-if='item.cover_image !=null' :src="$api.$BASE_URL_img + item.cover_image" alt="">
						</div>
						<div>
							<p><span v-for="(bookNam,boIdx) in item.book_name" v-if="boIdx >4 ? false : true">{{bookNam}}</span></p>
							<p><span v-for="(authorTxt,boIdx) in item.author" v-if="boIdx >4 ? false : true">{{authorTxt}}</span></p>
							<p><span v-for="(introduceTxt,boIdx) in item.introduce" v-if="boIdx >10 ? false : true">{{introduceTxt}}</span></p>
						</div>
					</div>
					<div class="bookNameList">
						<p v-for="(item,index) in gdcy.list" v-if="index>0&&index<4" :key='index' @click="jumpBookinfo(item.book_id)">{{item.book_name}}</p>
					</div>
				</div>
			</div>
			<div class="jinpinBox">
				<div class="jinpin_left">
					<div class="jp_title" @click="jumpXdyq(gthj.plate_info_id)">
						<h4>幻想百合</h4>
						<div>
							<img src="../../assets/img/rightarr_pink.png" alt="">
						</div>
					</div>
					<div class="jp_bookName" v-if="index==0" @click="jumpBookinfo(item.book_id)" v-for='(item,index) in gthj.list'
					 :key='index'>
						<div class="jp_bookImg">
							<img v-if='item.cover_image !=null' :src="$api.$BASE_URL_img + item.cover_image" alt="">
						</div>
						<div>
							<p><span v-for="(bookNam,boIdx) in item.book_name" v-if="boIdx >4 ? false : true">{{bookNam}}</span></p>
							<p><span v-for="(authorTxt,boIdx) in item.author" v-if="boIdx >4 ? false : true">{{authorTxt}}</span></p>
							<p><span v-for="(introduceTxt,boIdx) in item.introduce" v-if="boIdx >10 ? false : true">{{introduceTxt}}</span></p>
						</div>
					</div>
					<div class="bookNameList">
						<p v-for="(item,index) in gthj.list" v-if="index>0&&index<4" :key='index' @click="jumpBookinfo(item.book_id)">{{item.book_name}}</p>
					</div>
				</div>

			</div>

			<!-- 最近更新 -->
			<div class="updateBook">
				<div class="updata_tit">
					<p v-for="(item,index) in editList" :key="index" :class="updataEditShow == index ? 'active' : false" @click="updataEdit(index)">{{item.name}}
						<span v-if="index == 2 || index == 5 ? false : true">{{item.txt}}</span></p>
				</div>
				<!-- <div class="updataName" v-for="(item,id)  in  updataEditdata" v-if="updataEditShow == item.id" :key="item.id">
					<p v-for="(item,index) in item.name" :key="index">{{item}}</p>
				</div> -->
				<div class="updataName" v-if="updataEditShow == 0">
					<p v-for='(item,index) in bianji' :key='index' 
					v-if="!lookMoreShow ? ((!item.book_name || index > 12) ? false : true) : (!item.book_name ? false : true)"
					@click='jumpBookinfo(item.book_id)'>{{item.book_name}}</p>
				</div>
				<div class="updataName" v-if="updataEditShow == 1">
					<p v-for='(item,index) in vip' :key='index' 
					v-if="!lookMoreShow ? ((!item.book_name || index > 12) ? false : true) : (!item.book_name ? false : true)"
					@click='jumpBookinfo(item.book_id)'>{{item.book_name}}</p>
				</div>
				<div class="updataName" v-if="updataEditShow == 2">
					<p v-for='(item,index) in mengxin' :key='index' 
					v-if="!lookMoreShow ? ((!item.book_name || index > 12) ? false : true) : (!item.book_name ? false : true)"
					@click='jumpBookinfo(item.book_id)'>{{item.book_name}}</p>
				</div>
				<div class="updataName" v-if="updataEditShow == 3">
					<p v-for='(item,index) in yuedu' :key='index' 
					v-if="!lookMoreShow ? ((!item.book_name || index > 12) ? false : true) : (!item.book_name ? false : true)"
					@click='jumpBookinfo(item.book_id)'>{{item.book_name}}</p>
				</div>
				<div class="updataName" v-if="updataEditShow == 4">
					<p v-for='(item,index) in jidu' :key='index' 
					v-if="!lookMoreShow ? ((!item.book_name || index > 12) ? false : true) : (!item.book_name ? false : true)"
					@click='jumpBookinfo(item.book_id)'>{{item.book_name}}</p>
				</div>
				<div class="updataName" v-if="updataEditShow == 5">
					<p v-for='(item,index) in mianfei' :key='index' 
					v-if="!lookMoreShow ? ((!item.book_name || index > 12) ? false : true) : (!item.book_name ? false : true)"
					@click='jumpBookinfo(item.book_id)'>{{item.book_name}}</p>
				</div>
				<div class="lookMore" @click="lookMore"><span>{{looktitle}}&nbsp;&gt;</span></div>
			</div>
			<!-- 全屏最亮的仔 -->
			<div class="updateBook">
				<h4>全频道最靓的仔</h4>
				<div class="updataName">
					<p @click='jumpBookinfo(item.book_id)' v-if="item.book_name != null" v-for='(item,index) in qpzl' :key='index'>{{item.book_name}}</p>
				</div>
			</div>
			<!-- 书单共享 -->
			<div class="blockHouse">
				<div class="blockHouse_tit">
					<div class="blockHouse_left">
						<h4>书单共享</h4>
						<p class="updata_yp" @click="hypFn">换一批</p>
					</div>
				</div>
				<div class="sdmc_box" @click="go_bookshelfInfo()">
					<div class="sdmc_right">
						<span>《{{shareInfo.name}}》</span>
						<p>{{shareInfo.maker}}</p>
					</div>
				</div>
				<p class="jianjie" v-html="shareInfo.describe"></p>
				<div @click="go_bookshelfInfo()">
					<ul>
						<!-- @click="jumpBookinfo(item.id)" -->
						<li v-for="(item,index) in sdgxList" :key="index" v-if="index<=3" >
							<img v-if="item.cover_image !=null" :src="$api.$BASE_URL_img + item.cover_image" />
							<p class="bookName"><span v-for="(bookNam,boIdx) in item.book_name" v-if="boIdx >3 ? false : true">{{bookNam}}</span></p>
						</li>
					</ul>
				</div>
			</div>
		</div>
		</van-pull-refresh>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				tabArrindex: null,
				updataEditShow: 0, //编辑强推榜默认显示项
				editList: [{
						name: "编辑强推榜",
						txt: '|'
					},
					{
						name: "VIP新文榜",
						txt: '|'
					},
					{
						name: "萌新作者榜",
						txt: '|'
					}, {
						name: "月度榜",
						txt: '|'
					},
					{
						name: "季度榜",
						txt: '|'
					},
					{
						name: "免费完结榜",
						txt: '|'
					}
				],
				// 编辑显示项
				updataEditdata: {},

				jb_swiperOption: {
					slidesPerView: 'auto',
					spaceBetween: 30,
					loop: false,
				},
				gyjb: [],
				jzxs: [],
				fmqt: [],
				rdgz: [],
				xttj: [],
				gdyq: [],
				gdcy: [],
				gthj: [],
				qydz: [],
				sjjh: [],
				szry: [],
				bianji: [],
				vip: [],
				mengxin: [],
				yuedu: [],
				jidu: [],
				mianfei: [],
				qpzl: [], //全屏最亮
				sdgxList: [],
				lookMoreShow: false,
				looktitle: '查看更多',
				shareInfo:'',
				isLoading: false,
				categoryIdx: null,
			}
		},
		created() {
			this.get_third_category_list();
			this.hypFn();
			this.categoryIdx = this.$route.query.categoryIdx;
		},
		methods: {
			onRefresh() {
				setTimeout(() => {
					// Toast('已获取到最新数据');
					this.get_third_category_list();
					this.isLoading = false;
				}, 1000);
			},
			lookMore(){
				if(this.lookMoreShow){
					this.lookMoreShow = false;
					this.looktitle = '查看更多';
				}else{
					this.lookMoreShow = true;
					this.looktitle = '收起更多';
				}
			},
			hypFn() {
				//书单共享
				this.$axios.post(this.$api.booklist_share).then(res => {
					if(res.data.code == 1){
						this.shareInfo = res.data.data;
					}
					if (res.data.data.book != []) {
						this.sdgxList = res.data.data.book;
					} else {
						Toast('暂无最新数据')
					}
				})
			},
			jumpXdyq(id) {
				console.log(id)
				this.$router.push({
					path: "/gudaiyanqing",
					query: {
						plate_info_id: id
					}
				})
			},
			// 编辑强推榜
			updataEdit(data) {
				this.updataEditShow = data
			},
			// 跳转详情页
			jumpBookinfo(val) {
				this.$router.push({
					path: '/bookinfo',
					query: {
						id: val,
						getSecond_tab: 4,
						getFirstvalue_tab: 2,
						url: 'chunai'
					}
				})
			},
			//三级分类页面数据  古代言情
			get_third_category_list() {
				this.$axios.post(`${this.$api.third_category_list}?category_id=34`).then(res => {
					console.log(res, '三级分类页面数据 百合')
					this.gyjb = res.data.data[0].list
					this.jzxs = res.data.data[1].list
					this.fmqt = res.data.data[2].list
					this.rdgz = res.data.data[3].list.group2.list
					this.xttj = res.data.data[3].list.group1.list
					this.gdyq = res.data.data[5].list.group1
					this.gdcy = res.data.data[5].list.group2
					this.gthj = res.data.data[5].list.group3
					this.bianji = res.data.data[4].list.group3.list
					this.vip = res.data.data[4].list.group4.list
					this.mengxin = res.data.data[4].list.group5.list
					this.yuedu = res.data.data[4].list.group6.list
					this.jidu = res.data.data[4].list.group7.list
					this.mianfei = res.data.data[4].list.group8.list
					this.qpzl = res.data.data[6].list;
				})
			},
			go_bookshelfInfo() {
				this.$router.push({
					path: "/bookdyinfo",
					query: {
						id: this.shareInfo.id,
						name: 'gxsd'
					}
				})
			}
		}
	}
</script>

<style scoped="scoped" lang="less">
	.yanqingBox {
		background-color: #f0f0f0;
		overflow-y: scroll;
		height: calc(100vh - 160px);
		color: #000;
		// 头部
		.headerBox {
			height: 160px;
			background-color: #ff4081;
			display: flex;
			background: url(../../assets/img/myicon/indexBgc.png) no-repeat 0% 88%;
			background-size: 100%;
			background-color: #ffffff;
			border-bottom: 1px solid #f0f0f0;

			/*no*/
			.headerQuery {
				margin-top: 70px;
				padding: 0 16px;
				position: relative;
				display: flex;
				width: 100%;
				height: 90px;
				line-height: 90px;
				color: #000;

				.arrImg {
					img {
						width: 40px;
						position: absolute;
						top: 50%;
						transform: translateY(-50%);
						left: 0px;
					}
				}

				.header_titile {
					flex: 1;
					text-align: center;
					font-size: 34px;
					/*px*/
				}
			}

		}

		// tabbar
		.second_box {
			display: flex;
			justify-content: space-between;
			line-height: 70px;
			padding: 0px 16px;
			background-color: #fff;
			border-bottom: 1px solid pink;

			/*no*/
			a {
				font-size: 28px;
			}

			.active {
				transform: scale(1.1);
				color: #ff4081;
			}
		}

		// 公告css
		.advite_gg {
			display: flex;
			padding: 10px 16px;
			height: 68px;
			line-height: 68px;
			background-color: #fff;
			overflow: hidden;
			position: relative;

			.laba {
				img {
					width: 50px;
					position: absolute;
					top: 50%;
					left: 16px;
					transform: translateY(-50%);
					// height: 66px;
				}
			}

			.swiper_vertical {
				width: calc(100vw - 182px);
				position: absolute;
				top: 50%;
				left: 65px;
				transform: translateY(-50%);
				height: 50px;
				line-height: 50px;
				font-size: 28px;
				/*px*/
				color: #686f70;
				overflow: hidden;
				padding-left: 20px;
				border-radius: 50px;
				background-color: rgba(129, 197, 247, .2);

				.van-swipe .van-swipe__track--vertical .van-swipe-item {
					overflow: hidden;
					white-space: nowrap;
					text-overflow: ellipsis;
				}
			}
		}

		// 古言金榜
		.yunjin_jbBox {
			height: 390px;
			background-color: #fff;
			border-top: 8px solid #f0f0f0;
			padding: 20px 16px;

			h4 {
				display: inline-block;
				color: #ff4081;
				font-size: 30px;
				/*px*/
				height: 50px;
				line-height: 50px;
				font-weight: 700;
				position: relative;

				img {
					width: 40px;
					position: absolute;
					top: -15px;
					right: -26px;
				}
			}

			.yunjin_jb {
				margin-top: 10px;
				height: 340px !important;

				.swiper-container {
					height: 100%;

					.swiper-slide {
						width: 28%;
						margin-right: 15px !important;

						div {
							text-align: center;

							img {
								width: 190px;
								height: 270px;
								/*px*/
								vertical-align: middle;
								-webkit-box-shadow: 0 3px 3px 0px rgba(0, 0, 0, 0.3);
								/*no*/
								-moz-box-shadow: 0 3px 3px 0px rgba(0, 0, 0, 0.3);
								/*no*/
								box-shadow: 0 3px 3px 0px rgba(0, 0, 0, 0.3);
								/*no*/
							}
						}

						.bookName,
						.jianjie {
							font-size: 30px;
							/*px*/
							overflow: hidden;
							white-space: nowrap;
							// text-overflow: ellipsis;s
							padding-top: 10px;
							color: #000;
						}

						.jianjie {
							font-size: 24px;
							/*px*/
							color: #000;
							padding-top: 15px;
							opacity: 0.6;
						}
					}
				}
			}
		}

		//佳作欣赏
		.shouyeQt {
			background-color: #fff;
			margin-top: 10px;
			padding: 0 16px;

			h4 {
				color: #ff4081;
				font-size: 30px;
				/*px*/
				font-weight: 700;
				height: 74px;
				line-height: 74px;
			}

			.qt_list {
				overflow: hidden;

				p {
					display: block;
					width: calc(50% - 40px);
					margin-right: 10px;
					padding-right: 10px;
					height: 60px;
					overflow: hidden;
					white-space: nowrap;
					float: left;
					text-align: left;
					font-size: 30px;
					/*px*/
					line-height: 60px;
					color: #000;
				}

				p:nth-child(2n) {
					padding-left: 30px;
				}
			}

		}

		//热点关注
		.hot_gz {
			padding: 10px 16px;
			background-color: #fff;
			margin-top: 10px;

			h4 {
				color: #ff4081;
				font-size: 30px;
				/*px*/
				font-weight: 700;
				height: 50px;
				line-height: 50px;
			}

			.hotLists {
				overflow: hidden;

				p {
					display: block;
					width: calc(50% - 40px);
					margin-right: 10px;
					padding-right: 10px;
					height: 60px;
					overflow: hidden;
					white-space: nowrap;
					float: left;
					text-align: left;
					font-size: 30px;
					/*px*/
					line-height: 60px;
					color: #000;
				}

				p:nth-child(2n) {
					padding-left: 30px;
				}
			}
		}

		//精品
		.jinpinBox {
			margin-top: 10px;
			overflow: hidden;
			background-color: #fff;

			.jinpin_left {
				width: calc(50% - 31px);
				margin-bottom: 10px;
				background-color: #fff;
				float: left;
				padding-left: 16px;
				padding-right: 25px;
				padding-bottom: 16px;
				overflow: hidden;

				.jp_title {
					display: flex;
					height: 78px;
					line-height: 78px;
					position: relative;

					h4 {
						flex: 1;
						font-size: 30px;
						/*px*/
						color: #ff4081;
					}

					div {
						img {
							position: absolute;
							top: 50%;
							transform: translateY(-50%);
							right: 34px;
							width: 50px;
						}
					}
				}

				.jp_bookName {
					display: flex;
					height: 240px;
					position: relative;

					.jp_bookImg {
						position: absolute;
						top: 50%;
						left: 0;
						transform: translateY(-50%);
						width: 155px;
						height: 220px;
						/*px*/
						-webkit-box-shadow: 0 3px 3px 0 rgba(0, 0, 0, .3);
						/*no*/
						-moz-box-shadow: 0 3px 3px 0 rgba(0, 0, 0, .3);
						/*no*/
						box-shadow: 0 3px 3px 0 rgba(0, 0, 0, .3);

						/*no*/
						img {
							width: 155px;
							height: 220px;
							/*px*/
							display: block;
						}
					}

					div:last-child {
						position: absolute;
						top: 50%;
						right: 0;
						transform: translateY(-50%);
						text-align: left;
						width: 50%;

						p:first-child {
							// width: 120px;
							font-size: 30px;
							/*px*/
							// font-weight: bold;
							margin-bottom: 10px;
							line-height: 40px;
							height: 40px;
							overflow: hidden;
							color: rgba(0, 0, 0, 1);
						}

						p:nth-child(2) {
							font-size: 26px;
							/*px*/
							line-height: 40px;
							height: 40px;
							overflow: hidden;
							padding-bottom: 10px;
							color: rgba(0, 0, 0, 1);
							opacity: 0.6;
						}

						p:last-child {
							overflow: hidden;
							line-height: 40px;
							height: 80px;
							color: rgba(0, 0, 0, 1);
							opacity: 0.4;
							font-size: 24px;
							/*px*/
						}
					}
				}

				.bookNameList {
					line-height: 50px;
					font-size: 30px;
					/*px*/
					padding-top: 10px;
				}
			}

			.jinpin_left:nth-child(2n) {
				padding-right: 16px;
				padding-left: 5px;
			}

		}

		// 查看更多
		.bookMore {
			margin-top: 10px;
			background-color: #fff;
			padding: 0 16px;

			.soltType {
				padding: 20px 0;

				span {
					font-size: 30px;
					/*px*/
					display: inline-block;
					padding: 0 16px;
					color: #fa7298;
				}

				.line {
					padding: 25px;
					color: #dbdbdb;
				}

			}

			.bookName {
				line-height: 80px;
				overflow: hidden;
				padding: 0 16px;

				p {
					width: 50%;
					float: left;
					font-size: 28px;
					/*px*/
					color: #585858;
				}
			}

			.btnMore {
				text-align: center;
				line-height: 50px;
				color: #9a9a9a;
				padding: 20px;
				font-size: 30px;
				/*px*/
			}
		}

		//半价完结榜
		.banjia_solt {
			background: #fff;

			.banjia_title {
				position: relative;
				height: 80px;
				display: flex;
				justify-content: space-between;
				line-height: 80px;

				span {
					font-size: 30px;
					/*px*/
					padding: 0 16px;
					color: #ff4081;
					font-weight: 700;
				}

				.jp_bookImg {

					height: 50px;

					img {
						position: absolute;
						top: 50%;
						right: 34px;
						transform: translateY(-50%) rotate(270deg);
						width: 35px;
					}
				}
			}
		}

		//最近更新
		.updateBook {
			// margin-bottom: 10px;
			margin-top: 10px;
			background-color: #fff;
			padding: 0 16px;

			h4 {
				// color: #fa7089;
				color: #ff4081;
				font-weight: 700;
				font-size: 30px;
				/*px*/
				height: 50px;
				line-height: 50px;
				padding-top: 20px;
				padding-bottom: 20px;
			}

			.updata_tit {
				font-size: 28px;
				/*px*/
				color: #ff4081;
				// display: flex;
				overflow: hidden;

				p {
					width: 33%;
					float: left;
					display: inline-block;
					line-height: 80px;
					overflow: hidden;
					text-align: left;

					>span {
						width: 33%;
						float: right;
						color: #dbdbdb;
						text-align: center;
					}
				}

				p.active {
					font-size: 30px;
					/*px*/
					font-weight: bold;
					color: #ff4081;
					// background: url(../../assets/img/typebgc.png) no-repeat  20%;
					background-position: -50% 50%;
				}
			}

			.updataName {
				overflow: hidden;
				line-height: 60px;

				p {
					display: block;
					width: calc(50% - 40px);
					margin-right: 10px;
					padding-right: 10px;
					height: 60px;
					overflow: hidden;
					white-space: nowrap;
					float: left;
					text-align: left;
					font-size: 30px;
					/*px*/
					line-height: 60px;
					color: #000;
				}

				p:nth-child(2n) {
					padding-left: 30px;
				}
			}

			//查看更多
			.lookMore {
				text-align: center;
				line-height: 80px;
				font-size: 28px;
				/*px*/
				color: #9a9a9a;
			}

		}

		//书单共享
		.blockHouse {
			// background-color: #fff;
			margin-top: 10px;
			// background: url('../../assets/img/sdgx_01.png') repeat;
			background-color: #F8FAFF;
			.blockHouse_tit {
				padding: 0 16px;
				// line-height: 50px;
				color: #000;
				padding-top: 20px;
		
				.blockHouse_left {
					display: flex;
					justify-content: space-between;
		
					h4 {
						font-size: 30px;
						/*px*/
						font-weight: 700;
						padding-bottom: 20px;
						display: inline-block;
						padding-right: 20px;
						color: #ff4081;
					}
		
					.updata_yp {
						font-size: 28px;
						/*px*/
						color: #ff4081;
					}
				}
		
				.blockHouse_footer {
					vertical-align: middle;
					padding: 0px 20px;
					padding-bottom: 10px;
					text-align: center;
					width: 72%;
					margin: 0 auto;
					height: 40px;
					line-height: 40px;
					border-radius: 40px;
					-webkit-box-shadow: 1px 2px 4px 1px rgba(255, 64, 129, .6);
					/*no*/
					-moz-box-shadow: 1px 2px 4px 1px rgba(255, 64, 129, .6);
					/*no*/
					box-shadow: 1px 2px 4px 1px rgba(255, 64, 129, .6);
					/*no*/
					position: relative;
		
					p {
		
						padding: 5px 0;
						color: #000000;
						font-size: 26px;
						/*px*/
						font-weight: 500;
					}
		
					.gy_sdicon {
						position: absolute;
						bottom: -20px;
						left: -20px;
						width: 60px;
					}
				}
			}
		
			.bookname {
				padding: 0px 16px;
				padding-bottom: 10px;
				color: #ff4081;
				line-height: 40px;
				font-size: 28px;
				/*px*/
			}
			.jianjie{
				padding: 0px 31px;
				padding-right: 16px;
				font-size: 30px;/*px*/
				color: #292b2d;
				line-height: 60px;
			}
			.sdmc_box {
				padding: 0 16px;
				position: relative;
				// .sdmc_left{
				// 	img{
				// 		width: 80px;/*px*/
				// 	}
				// }
				.sdmc_right{
					font-size: 30px;/*px*/
					span{
						color:#000000;
					}
					p{
						padding-left: 10px;
						color: #9d9b8f;
						font-size: 26px;/*px*/
						padding-top: 20px;
						padding-bottom: 10px;
						padding-left: 15px;
					}
				}
			}
		
			ul {
				margin: 10px 16px;
				margin-top: 0;
				overflow-x: scroll;
				overflow-y: hidden;
				// -webkit-box-shadow: 1px 2px 4px 1px rgba(0, 0, 0, .2);/*no*/
				// -moz-box-shadow: 1px 2px 4px 1px rgba(0, 0, 0, .2);/*no*/
				// box-shadow: 1px 2px 4px 1px rgba(0, 0, 0, .2);/*no*/
				// border: 1px solid #ff71a1;
				/*no*/
				// border-radius: 20px;
				// background-color: #fff8fa;
		
				li {
					float: left;
					width: calc(25% - 8px);
					text-align: center;
					margin: 0 auto;
					margin-right: 10px;
					text-align: center;
					padding: 20px 0;
		
					img {
						width: 155px;
						height: 220px;
						vertical-align: middle;
						-webkit-box-shadow:0px 3px 3px 0px rgba(0, 0, 0, 0.3);
						/*no*/
						-moz-box-shadow: 0px 3px 3px 0px rgba(0, 0, 0, 0.3);
						/*no*/
						box-shadow: 0px 3px 3px 0px rgba(0, 0, 0, 0.3);
						/*no*/
					}
		
					.bookName,
					.jianjie {
						overflow: hidden;
						white-space: nowrap;
						width: 89%;
						margin: 0 auto;
						// text-overflow: ellipsis;
					}
		
					.bookName {
						color: #000;
						font-size: 30px;
						/*px*/
						padding-top: 10px;
					}
				}
		
				li:last-child {
					margin-right: 0;
				}
			}
		}
		}
</style>
